import { Reveal, Eyebrow } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

const PLAYLIST_EMBED =
  "https://open.spotify.com/embed/playlist/7xSv6OXfw6pQawi7nCCPdo?utm_source=generator";

export const Soundtrack = () => {
  const { t } = useLang();
  return (
    <section
      id="soundtrack"
      data-testid="soundtrack-section"
      className="py-24 md:py-36 bg-foreground text-background"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <Reveal>
            <Eyebrow>{t.soundtrack.eyebrow}</Eyebrow>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-5 leading-tight">
              {t.soundtrack.title}
            </h2>
            <p className="mt-6 text-background/60 font-light max-w-md leading-relaxed">
              {t.soundtrack.p}
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <iframe
              data-testid="spotify-player"
              title="Tribe Beach Lounge Spotify playlist"
              src={PLAYLIST_EMBED}
              width="100%"
              height="420"
              frameBorder="0"
              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
              loading="lazy"
              style={{ borderRadius: "12px" }}
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
